module.exports = __webpack_public_path__ + "fonts/GalanoGrotesque-Regular.98353e6.woff2";